import React from "react";
import Image1 from '../Images/Image1.svg';
import Image2 from '../Images/Image2.svg';
import Image3 from '../Images/Image3.svg';
import Image4 from '../Images/Image4.svg';
import Image5 from '../Images/Image5.svg';
import Image6 from '../Images/Image6.svg';
import Image7 from '../Images/Image7.svg';
import LeftImage1 from '../Images/LeftImag1.svg';
import LeftImage2 from '../Images/LeftImage2.svg';
import RightImage1 from '../Images/RightImage1.svg';
import RightImage2 from '../Images/RightImage2.svg';
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function HomeScreen() {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        overflowX: 'hidden'
      }}
    >
      <Header />

      {/* Main Centered Content */}

      {/* First Part */}
      <div className="section-container">
        {/* Internal CSS */}
        <style>
          {`
          .section-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 40px 60px;
            background-color: white;
          }

          .section-text {
            flex: 1;
            color: #000;
            align-items: left;
          }

          .section-text h3 {
            font-size: 18px;
            color: #FA4A0C;
            margin: 0;
            text-align: left;
          }

          .section-text h1 {
            font-size: 42px;
            margin: 15px 0;
            line-height: 1.2;
            text-align: left;
          }

          .section-text p {
            font-size: 16px;
            color: #555;
            text-align: left;
          }

          .section-image {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .section-image img {
            width: 100%;
            max-width: 500px;
            height: auto;
          }

          /* 📱 Responsive */
          @media (max-width: 768px) {
            .section-container {
              flex-direction: column;
              text-align: center;
              padding: 20px;
            }

            .section-image {
              margin-top: 20px;
            }

            .section-text h1 {
              font-size: 28px;
            }

            .section-text p {
              font-size: 14px;
            }

            .section-image img {
              max-width: 80%;
            }
          }
        `}
        </style>

        {/* Left Side - Text */}
        <div className="section-text">
          <h3>Get Started</h3>
          <h1>
            We Support Businesses <br /> To Deliver Their Online Orders
          </h1>
          <p>
            Increase your Local and Offline Delivery into Online and Make your
            Business Wider & Longer.
          </p>
        </div>

        {/* Right Side - SVG Image */}
        <div className="section-image">
          <img src={Image1} alt="Business delivery support" width="500" height="400" />
        </div>
      </div>

      {/* Second Part */}
      <div>
        <div className="main">
          <style>
            {`
          .main {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            width: 100%;
            background-color: white;
            padding: 20px;
          }

          .main h1 {
            color: black;
            font-size: 33px;
            margin: 5px 0;
            line-height: 1.2;
          }

          /* 📱 Mobile Responsive */
          @media (max-width: 768px) {
            .main h1 {
              font-size: 24px;
            }
          }
        `}
          </style>

          <h1>We Support Businesses</h1>
          <h1>Take Into Next Level</h1>
        </div>
        <div className="main-container">
          <style>
            {`
          .main-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 40px 60px;
            background-color: white;
            flex-wrap: wrap;
          }

          .side-box {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 400px;
          }

          .text-box {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 12px;
            padding: 20px;
            margin: 10px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          }

          .text-box h3 {
            color: #FA4A0C;
            font-size: 18px;
            margin: 0 0 10px 0;
          }

          .text-box p {
            color: #363D4F;
            font-size: 15px;
            margin: 0;
          }

          .center-image {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .center-image img {
            width: 100%;
            max-width: 350px;
            height: auto;
          }

          .left-image {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .left-image img {
            width: 100%;
            max-width: 50px;
            height: auto;
          }

          /* 📱 Responsive for Mobile */
          @media (max-width: 900px) {
            .main-container {
              flex-direction: column;
              align-items: center;
              padding: 20px;
            }

            .side-box {
              flex-direction: row;
              justify-content: center;
              height: auto;
              width: 100%;
              margin-bottom: 20px;
            }

            .text-box {
              width: 45%;
              margin: 5px;
              text-align: center;
            }

            .center-image img {
              max-width: 80%;
            }
          }

          @media (max-width: 600px) {
            .side-box {
              flex-direction: column;
              align-items: center;
            }

            .text-box {
              width: 80%;
            }
          }
            .know-more-btn {
  background-color: #FA4A0C; /* Orange */
  color: white; /* White font */
  border: none;
  padding: 19px 20px;
  border-radius: 25px;
  margin-top: 15px;
  font-size: 15px;
  cursor: pointer;
  transition: 0.3s ease;
}

.know-more-btn:hover {
  background-color: #d93d08; /* dark orange */
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
}

/* Mobile */
@media (max-width: 600px) {
  .know-more-btn {
    width: 100%;
    text-align: center;
  }
}
.know-more-link {
  text-decoration: none;
}

        `}
          </style>

          {/* Left Side */}
          <div className="side-box">
            <div className="text-box">
              <div className="left-image">
                <img src={LeftImage1} alt="Center illustration" />
              </div>
              <h3>Create order</h3>
              <p>Easy way to create order and post.</p>
            </div>
            <div className="text-box">
              <div className="left-image">
                <img src={LeftImage2} alt="Center illustration" />
              </div>
              <h3>Track orders</h3>
              <p>Track all your current and all delivered order status</p>
            </div>
          </div>

          {/* Center Image */}
          <div className="center-image">
            <img src={Image2} alt="Center illustration" width="350" height="350" />
          </div>

          {/* Right Side */}
          <div className="side-box">
            <div className="text-box">
              <div className="left-image">
                <img src={RightImage1} alt="Center illustration" />
              </div>
              <h3>Live tracking</h3>
              <p>Live Track your current orders with  live location</p>
            </div>
            <div className="text-box">
              <div className="left-image">
                <img src={RightImage2} alt="Center illustration" />
              </div>
              <h3>Available partner</h3>
              <p>View all your available partners near by you</p>
            </div>

          </div>

        </div>
<Link to="/despatch" className="know-more-link">
    <button className="know-more-btn">Know More</button>
  </Link>
      </div>


      {/* Third Part */}
      <div>
        <div style={{ height: 50 }}></div>

        <div className="main">
          <style>
            {`
          .main {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            width: 100%;
            background-color: white;
            padding: 20px;
          }

          .main h1 {
            color: black;
            font-size: 33px;
            margin: 5px 0;
            line-height: 1.2;
          }

          /* 📱 Mobile Responsive */
          @media (max-width: 768px) {
            .main h1 {
              font-size: 24px;
            }
          }
        `}
          </style>
          <h1>Delivery Partner App</h1>
        </div>
        <div className="main-container">
          <style>
            {`
          .main-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 40px 60px;
            background-color: white;
            flex-wrap: wrap;
          }

          .side-box {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 400px;
          }

          .text-box {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 12px;
            padding: 20px;
            margin: 10px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          }

          .text-box h3 {
            color: #FA4A0C;
            font-size: 18px;
            margin: 0 0 10px 0;
          }

          .text-box p {
            color: #363D4F;
            font-size: 15px;
            margin: 0;
          }

          .center-image {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .center-image img {
            width: 100%;
            max-width: 350px;
            height: auto;
          }

          .left-image {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .left-image img {
            width: 100%;
            max-width: 50px;
            height: auto;
          }

          /* 📱 Responsive for Mobile */
          @media (max-width: 900px) {
            .main-container {
              flex-direction: column;
              align-items: center;
              padding: 20px;
            }

            .side-box {
              flex-direction: row;
              justify-content: center;
              height: auto;
              width: 100%;
              margin-bottom: 20px;
            }

            .text-box {
              width: 45%;
              margin: 5px;
              text-align: center;
            }

            .center-image img {
              max-width: 80%;
            }
          }

          @media (max-width: 600px) {
            .side-box {
              flex-direction: column;
              align-items: center;
            }

            .text-box {
              width: 80%;
            }
          }
            .know-more-btn {
  background-color: #FA4A0C; /* Orange */
  color: white; /* White font */
  border: none;
  padding: 19px 20px;
  border-radius: 25px;
  margin-top: 15px;
  font-size: 15px;
  cursor: pointer;
  transition: 0.3s ease;
}

.know-more-btn:hover {
  background-color: #d93d08; /* dark orange */
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
}

/* Mobile */
@media (max-width: 600px) {
  .know-more-btn {
    width: 100%;
    text-align: center;
  }
}
  .know-more-link {
  text-decoration: none;
}

        `}
          </style>

          {/* Left Side */}
          <div className="side-box">
            <div className="text-box">
              <div className="left-image">
                <img src={LeftImage1} alt="Center illustration" />
              </div>
              <h3>Delivery in 10 Mins</h3>
              <p>Upload mantory Documents and Start your journey in 10 mins</p>
            </div>
            <div className="text-box">
              <div className="left-image">
                <img src={LeftImage2} alt="Center illustration" />
              </div>
              <h3>Part time job</h3>
              <p>Part time job and No flexible hours for working</p>
            </div>
          </div>

          {/* Center Image */}
          <div className="center-image">
            <img src={Image3} alt="Center illustration" width="350" height="350" />
          </div>

          {/* Right Side */}
          <div className="side-box">
            <div className="text-box">
              <div className="left-image">
                <img src={RightImage1} alt="Center illustration" />
              </div>
              <h3>Transfer Earnings</h3>
              <p>Instantly get your earnings directly in your bank account</p>
            </div>
            <div className="text-box">
              <div className="left-image">
                <img src={RightImage2} alt="Center illustration" />
              </div>
              <h3>Accept and Delivery</h3>
              <p>Accept and delivery your orders</p>
            </div>
          </div>

        </div>
<Link to="/partner" className="know-more-link">
    <button className="know-more-btn">Know More</button>
  </Link>
      </div>

      {/* Fourth part */}
      <div>
        <div className="main">
          <style>
            {`
          .main {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            width: 100%;
            background-color: white;
            padding: 20px;
          }

          .main h1 {
            color: black;
            font-size: 33px;
            margin: 5px 0;
            line-height: 1.2;
          }

          /* 📱 Mobile Responsive */
          @media (max-width: 768px) {
            .main h1 {
              font-size: 24px;
            }
          }
        `}
          </style>
          <h6 style={{ color: '#FA4A0C' }}>Powerful Features</h6>
          <h1>Our product has these</h1>
          <h1>big features</h1>
        </div>

        <div className="three-box-section">
          <style>
            {`
      .three-box-section {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 30px;
        padding: 40px 20px;
        background-color: white;
        text-align: center;
      }

      .text-box {
        flex: 1;
        min-width: 260px;
        max-width: 320px;
        background-color: #f8f9fa;
        border-radius: 12px;
        padding: 25px 20px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
      }

      .text-box:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
      }

      .left-image img {
        width: 80px;
        height: 80px;
        margin-bottom: 15px;
      }

      .text-box h3 {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 20px;
        color: #000;
        font-weight: 600;
        margin: 10px 0 8px;
      }

      .text-box h3 img {
        width: 25px;
        height: 25px;
      }

      .text-box p {
        font-size: 15px;
        color: #555;
        margin: 0;
      }

      /* 📱 Mobile Responsive */
      @media (max-width: 768px) {
        .three-box-section {
          flex-direction: column;
          gap: 20px;
        }

        .text-box {
          max-width: 90%;
        }
      }
    `}
          </style>

          {/* Box 1 */}
          <div className="text-box">
            <div className="left-image">
              <img src={Image4} alt="Create order" width="80" height="80" />
            </div>
            <h3>
              <img src={Image7} alt="icon" width="25" height="25" />
              Deliver and Earn
            </h3>
            <p>Easy acceptance of order and deliver. Instantly get money in your account</p>
          </div>

          {/* Box 2 */}
          <div className="text-box">
            <div className="left-image">
              <img src={Image6} alt="Track order" width="80" height="80" />
            </div>
            <h3>
              <img src={Image7} alt="icon" width="25" height="25" />
              Part Time Job
            </h3>
            <p>Part time job and  flexible hourswork on your free time anywhere</p>
          </div>

          {/* Box 3 */}
          <div className="text-box">
            <div className="left-image">
              <img src={Image5} alt="Track order" width="80" height="80" />
            </div>
            <h3>
              <img src={Image7} alt="icon" width="25" height="25" />
              View All Incomes
            </h3>
            <p>Viewing day and week incomes. Directly money send in your bank account</p>
          </div>

        </div>
      </div>

      {/* Fifth Part */}

      <Footer />

    </div>

  );
}   
